export const PROFIT_AND_LOSS_STYLES = {
  CHATBOT_STYLE:
    'absolute top-[90vh] left-[1105px] pc-sm:left-[95%] pc-sm:top-[85%] z-40 w-[46px] h-[46px] rounded-full bg-action03 flex items-center justify-center cursor-pointer shadow-helpMenuButton hover:bg-action04',
  TRANSACTIONS_WRAPPER:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
  WRAPPER: 'bg-bw00 rounded-lg w-full',
  WRAPPER_HEADER: ' py-[16px] pl-[24px] pr-[16px] border-b-[0.8px] border-bw03 flex items-center justify-between',
  TITLE: 'font-metricR text-bw08 text-[20px]',
  CATEGORIZE_TITLE: 'font-metricR text-bw08 text-[20px] text-center mt-[40px]',
  BUTTON_WRAPPER: 'p-0.5 border-[1px] border-bw03 rounded-[5px] relative bg-[#fff]',
  DOWNLOAD_AND_PRINT:
    'min-w-[184px] justify-center rounded-[5px] py-[6px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[16px] flex-row-reverse flex cursor-pointer hover:bg-bw02',
  DOWNLOAD_OPTIONS_WRAPPER: ' top-[42px] left-0 bg-[#fff] p-0.5 border-[1px] border-bw03 rounded-[5px]',
  DOWNLOAD_SUB_BUTTON:
    'min-w-[184px] rounded-t-[4px] py-[9px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[14px] flex flex-start cursor-pointer hover:bg-bw02 bg-bw00',
  PRINT_SUB_BUTTON:
    'bg-[#fff] min-w-[184px] rounded-b-[4px] py-[9px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[14px] flex flex-start cursor-pointer hover:bg-bw02 bg-bw00',
  TIME_WRAPPER: 'flex align-center',
  DATE_INPUT:
    'focus:outline-none px-[4px]  w-full min-h-[36px] font-metricR text-bw08 text-[16px] rounded-r-[8px] cursor-pointer hover:bg-bw02',
  DATEPICKER: 'absolute border-[1px] rounded-md border-bw03 t-0 shadow-light mt-[4px] left-[-23%]',
  PERIOD_TYPE_SUB_BUTTON:
    'px-[8px] py-[8px] min-w-[100%] font-metricR text-bw08 text-[14px] flex align-items-[center] justify-between pointer hover:bg-bw02',
  PERIOD_TYPE_DISABLED_BUTTON:
    'px-[8px] py-[8px] min-w-[100%] font-metricR text-text-main-disabled hover:bg-bw00 text-[14px] flex align-items-[center] justify-between pointer',
  PERIOD_TYPE_SUB_BUTTON_ACTIVE:
    'flex items-center px-[8px] py-[8px] min-w-[100%] font-metricR text-action03 text-[14px] flex align-items-[center] justify-between pointer hover:bg-bw02',
  PERIOD_TYPE_SUB_BUTTON_LAST:
    'px-[8px] py-[8px] min-w-[100%] font-metricR text-bw08 text-[14px] flex align-items-[center] justify-between pointer hover:bg-bw02 rounded-b-[8px]',
  LAYOUT:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[96%] pc-md-lg:w-[96%] flex flex-col fadeIn',
  LAYOUT_CATEGORIZATION:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 pc-sm:w-[96%] pc-md-lg:w-[96%] flex flex-col fadeIn',

  PERIOD_TYPE_WRAPPER:
    'flex items-center border-[1px] border-outline-primary-bw-03 hover:border-outline-primary-bw-07 rounded-l-[8px] bg-bw00 h-[40px]',
  PERIOD_OPTION_WRAPPER: 'bg-bw00 absolute mt-[46px] w-[204px] translate-y-1/2 rounded-md border-[1px] border-bw03',
  SUB_BUTTON_WRAPPER_LAST: 'bg-bw00 absolute rounded-[8px]',
  SUB_BUTTON_WRAPPER: 'p-0.5 border-b-[1px] border-bw03',
  SUB_WRAPPER_LAST: 'p-0.5 border-0',
  CATEGORIZATION_SUB_TEXT: 'font-metricR text-bw07 text-[14px] font-normal text-center mb-[28px]',
  FIRST_PERIOD_BUTTON:
    'px-[8px] py-[8px] min-w-[100%] font-metricR text-bw08 text-[14px] flex align-items-[center] justify-between pointer hover:bg-bw02 rounded-t-[8px]',
  PERIOD_OUTLINE: ' rounded-l-[8px]  h-[40px]    z-10',
  DATEPICKER_OUTLINE:
    'p-[1px]  rounded-r-[8px] left-[-52%] top-[-1px] border-[1px] border-outline-primary-bw-07 outline-none z-10',
  NOT_CATEGORIZED_CONTAINER: 'relative bg-bw00 rounded-lg max-w-[70%] basis-[70%] mt-[16px]  select-none fadeIn',
  CATEGORIZED_CONTAINER: ' bg-bw00 rounded-lg max-w-[70%] basis-[70%] select-none mt-[16px]  fadeIn',
};

export const USERS_TYPES_STYLES = {
  WRAPPER: 'flex items-center w-full flex-col justify-center h-[calc(100%-75px)]',
  HEADER: 'font-metricR text-[24px] text-bw08 mt-[14px]',
  SUB_TEXT: 'font-metricR text-[16px] text-bw07 text-center',
  BUTTON: 'mx-auto max-h-[54px] w-[200px] mt-[30px]',
  GENERATE_BUTTON: 'mx-auto w-[220px] mt-0 mb-[30px]',
  GENERATE_BUTTON_DISABLED:
    'mx-auto mt-0 px-[40px] py-[17px] font-metricR text-[16px] text-bw00 rounded-[4px] bg-bw05 mb-[30px]',
  BUTTON_HEADER:
    'bg-action03 w-fit min-w-[181px] text-bw00 hover:bg-action04 font-metricMedium text-base py-[17px] px-[40px] rounded-[4px] mt-auto',
  IFRAME: 'w-[80%] block mt-[50px]',
  IFRAME_WRAPPER: 'flex justify-center h-[calc(100%-75px)]',
  CATEGORIZE_CONTROLLER: 'w-[690px] h-full bg-bw01 rounded-[8px] mr-[16px]',
  CATEGORIZE_SUMMARY: 'w-[344px] h-full bg-bw01 rounded-[8px]',
  CATEGORIZE_WRAPPER: 'flex justify-between',
  NAV_SWITCH_WRAPPER:
    'flex items-center gap-[6px] w-[280px] py-[4px] px-[2px] bg-bw02 border-[2px] border-bw03 rounded-[8px] mb-[34px]',
};

export enum ReportFlowStep {
  LOADER = 'LOADER',
  INTRO = 'INTRO',
  REQUIRED_UPGRADE_PLAN = 'REQUIRED_UPGRADE_PLAN',
  REPORT = 'REPORT',
  CATEGORIZE_TRANSACTIONS = 'CATEGORIZE_TRANSACTIONS',
  UPDATE_LOADER = 'UPDATE_LOADER',
  UPGRADE_PLAN = 'UPGRADE_PLAN',
}

export const PROFIT_AND_LOSS_TEXT = {
  DOWNLOAD_AND_PRINT: 'Download/Print',
  DOWNLOAD_OPTION: 'Download PDF',
  PRINT_OPTION: 'Print',
  PROFIT_AND_LOSS_UPGRADE_HEADER: 'Upgrade Now to Generate your Profit & Loss Report',
  CASH_AND_FLOW_UPGRADE_HEADER: 'Upgrade Now to Generate your Statement of Cash Flows',
  GENERATE_HEADER: 'Generate your Profit & Loss Report',
  GENERATE_CASH_FLOWS_HEADER: 'Generate your Statement of Cash Flows',
  UPGRADE_BUTTON: 'Upgrade Now',
  GET_STARTED: 'Get Started',
  TITLE: 'Profit and Loss',
  CATEGORIZATION_TITLE: 'Categorize Your Transactions',
  CATEGORIZATION_BUTTON: 'Generate the Report',
  CATEGORIZATION_TEXT:
    'In order to generate the report you need to finish the categorization of your remaining transactions',
  GENERATE_REPORT_TEXT: 'Choose a time frame and generate your',
  GENERATE_REPORT_SUB_TEXT: 'Profit & Loss report',
  CASH_FLOW: 'Statement of Cash Flows',
} as const;
